import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PageLoaderProps {
  /** Cover the full viewport (used by layout/auth gates rendered outside the page shell). */
  fullScreen?: boolean;
  className?: string;
}

/**
 * The single, canonical loading spinner for page-level loading states.
 *
 * Every page must render exactly one of these (centered in the middle of the
 * page) while its initial data loads — never multiple spinners at different
 * positions, and never the legacy thin `border-b-2` ring style.
 */
export function PageLoader({ fullScreen = false, className }: PageLoaderProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        fullScreen ? 'min-h-screen bg-background' : 'min-h-[calc(100vh-140px)]',
        className,
      )}
    >
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  );
}

export default PageLoader;
